module.exports = __webpack_public_path__ + "img/flower-type01-02.83f85f37.png";